import React, {useEffect} from 'react';
import {CircleLoading, Image, Label, NullMsgLabel, Section} from "../../common/fusion-ui";
import {useConfig} from "../context/ConfigProvider";
import {GenRouteUrls, Keys, ModuleRouteUrls, Modules} from "../config/AppConfig";
import {checkNullJson, checkNullStr, isBoolTrue} from "../../common/fusion-ui/utils/ReactUtils";
import {useTheme} from "../../common/ProjectThemeProvider";
import {ThemedButton} from "../index";
import {useAuth} from "../context/AuthProvider";
import {getUserSessionData} from "../utils/AppUtils";

const BypassTokenLoadingPanel = ({
                                     msg,
                                     loading,
                                     success,
                                     loadingLabel,
                                     shadowVariant = 'md',
                                     children,
                                 }) => {
    const TAG = "BypassTokenLoadingPanel";
    const {updateConfig} = useConfig();
    const {isAuthenticated} = useAuth(TAG);
    const theme = useTheme();

    useEffect(() => {
        updateConfig(Keys.tracker_currPageModule, TAG);
        updateConfig(Keys.tracker_currPageTag, TAG);
    }, []);

    return (<>
        {(isBoolTrue(loading) || !isBoolTrue(success)) &&
            <div className={'d-flex p-4 jc-center al-center bg-dangerx h-100'}>
                <Section className={`height90 p-0 m-0 mt-2 d-flex jc-center al-center bg-grayx`}
                         borderless={true}
                         shadowVariant={shadowVariant}>
                    <div>
                        {/*<div>*/}
                        {/*    <div>msg: {msg + ''}</div>*/}
                        {/*    <div>loading: {loading + ''}</div>*/}
                        {/*    <div>success: {success + ''}</div>*/}
                        {/*    <div>loadingLabel: {loadingLabel + ''}</div>*/}
                        {/*</div>*/}

                        {(isBoolTrue(loading) || isBoolTrue(loading)) && <div>
                            <div className={'d-flex jc-center al-center position-relative h-auto'}>
                                {/*logo in loading*/}
                                {/*<div className={'bg-warningx'}>*/}
                                {/*    {checkNullStr(getJsonValue(subdomainData, Keys.subdomain_DescriptionImg)) &&*/}
                                {/*        <Image*/}
                                {/*            wrapperClassName={'jc-center'}*/}
                                {/*            className={'rounded-4'}*/}
                                {/*            src={getJsonValue(subdomainData, Keys.subdomain_DescriptionImg)}*/}
                                {/*            width={'45px'}*/}
                                {/*            height={'45px'}*/}
                                {/*            disableDrag={true}*/}
                                {/*        />}*/}
                                {/*    <div className={'position-absolute bg-dangerx'} style={{top: '-38px', left: '38px'}}>*/}
                                <CircleLoading wrapperClassName={'m-1'} size={'105px'} borderWidth={'8px'}/>
                                {/*</div>*/}
                                {/*</div>*/}
                            </div>

                            {checkNullStr(loadingLabel) &&
                                <Label className={`fs-normal mt-4x px-2 py-1 ${(loadingLabel + '').endsWith('...') ? 'ms-3' : ''}`}
                                       color={theme.text}>
                                    {loadingLabel}
                                </Label>}
                        </div>}

                        {/*image*/}
                        {(!isBoolTrue(loading) && checkNullStr(msg)) && <div>
                            <Image
                                className={'rounded-3'}
                                width={'auto'}
                                height={'130px'}
                                disableDrag={true}
                                // src={'https://cdn.pixabay.com/photo/2012/04/14/17/05/warning-34621_1280.png'}
                                // src={'https://cdn.pixabay.com/photo/2013/07/13/12/09/sign-159285_1280.png'}
                                // src={'https://cdn.pixabay.com/photo/2012/04/24/13/19/exclamation-40026_1280.png'}
                                // src={'https://cdn.pixabay.com/photo/2017/02/12/21/29/false-2061132_1280.png'}
                                // src={'https://cdn.pixabay.com/photo/2018/01/04/15/51/404-error-3060993_1280.png'}
                                src={'https://cdn.pixabay.com/photo/2014/04/02/10/38/sign-304093_1280.png'}
                            />

                            <NullMsgLabel className={`fs-lg fw-semi-bold mt-n1 pt-1`} color={'var(--danger)'}>{msg + ''}</NullMsgLabel>

                            {/*login/home*/}
                            <div className={'mt-4 d-flex w-100 jc-center'}>
                                <ThemedButton
                                    className={'fs-normal px-4 fw-semi-bold'}
                                    text={checkNullJson(getUserSessionData()) ? 'Go to Home' : 'Login'}
                                    variant={theme.primaryBlue}
                                    hoverBgColor={theme.primaryBlueDark}
                                    sleek={true}
                                    href={checkNullJson(getUserSessionData()) ? ModuleRouteUrls[Modules.Dashboard] : GenRouteUrls.login}
                                    onLinkClick={(e) => {
                                        e.preventDefault();
                                    }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        window.location.href = checkNullJson(getUserSessionData()) ? ModuleRouteUrls[Modules.Dashboard] : GenRouteUrls.login;
                                    }}
                                />
                            </div>

                            {children && children}
                        </div>}
                    </div>
                </Section>
            </div>
        }
    </>)
}
export default BypassTokenLoadingPanel;
